import { React, useEffect } from 'react'
import HeaderCampaign from './HeaderCampaign'
import AboutCampaign from './AboutCampaign'
import FaqCampaign from './FaqCampaign'
import NavbarCampaign from '../../components/Commons/NavbarCampaign'
import FooterCampaign from '../../components/Layouts/FooterCampaign'
import { useSearchParams, useNavigate } from 'react-router-dom'
import { useCampaignValidation } from './hooks'
import Loading from '../../components/Commons/Loading/Loading'

const HomeCampaign = () => {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const token = searchParams.get('token')
  const { data, isLoading, error } = useCampaignValidation(token)

  useEffect(() => {
    if (!token || (!isLoading && error)) {
      navigate('/', { replace: true, state: { campaignFailed: true } })
    }
  }, [token, isLoading, error, navigate])

  useEffect(() => {
    if (data && token) {
      sessionStorage.setItem('campaignData', JSON.stringify(data))
      sessionStorage.setItem('campaignToken', token)
    }
  }, [data, token])

  if (isLoading) {
    return <Loading visible={isLoading} />
  }

  return (
    <div className="home">
      <NavbarCampaign campaignData={data} token={token} />
      <HeaderCampaign campaignData={data} token={token} />
      <AboutCampaign token={token} />
      <FaqCampaign />
      <FooterCampaign />
    </div>
  )
}

export default HomeCampaign
